import React from "react";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { products, SHOP_URL } from "../mock";

const Connectors = () => {
  return (
    <section id="connectors" className="relative bg-[#0e0e10] py-24 overflow-hidden">
      {/* Decorative glow */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#f15a24]/10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#f15a24]">
              The range
            </span>
            <h2 className="font-display font-medium text-white text-5xl sm:text-6xl mt-4">
              connectors
            </h2>
            <p className="text-neutral-400 mt-4 max-w-lg">
              A connector that meets the needs of today's OEMs — and it's so
              good, it's reusable.
            </p>
          </div>
          <a
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 self-start text-white font-semibold px-6 py-3 rounded-full border border-white/15 hover:border-[#f15a24] hover:bg-[#f15a24] transition-all duration-300"
          >
            See all products
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => (
            <a
              key={p.id}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-[#161618] border border-white/8 rounded-2xl overflow-hidden hover:border-[#f15a24]/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/3] bg-white overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-[11px] font-semibold tracking-wide uppercase text-[#f15a24] bg-[#f15a24]/10 px-2.5 py-1 rounded-full">
                  {p.tag}
                </span>
              </div>
              <div className="p-5 flex items-start justify-between gap-3">
                <div>
                  <h3 className="text-white font-semibold text-[15px] leading-snug group-hover:text-[#f15a24] transition-colors">
                    {p.name}
                  </h3>
                  <p className="text-neutral-400 text-sm mt-1.5">{p.price}</p>
                </div>
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-white/5 text-neutral-300 group-hover:bg-[#f15a24] group-hover:text-white transition-all duration-300 shrink-0">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Connectors;
